import { executeQuery, executeQuerySync } from './AppSyncPlusAPIs';

export const getAutomatedAppsByOwner = (appOwner, status, onSuccess, onFailure) => {
  const statusFilter = status ? `, status: "${status}"` : '';
  const qry = `query MyQuery {
    getAutomatedAppsByOwner(app_owner: "${appOwner}"${statusFilter})
  }`;
  executeQuery(qry, onSuccess, onFailure);
};

export const getAutomatedAppsByStatus = (status, onSuccess, onFailure) => {
  const qry = `query MyQuery {
    getAutomatedAppsByStatus(status: "${status}")
  }`;
  executeQuery(qry, onSuccess, onFailure);
};

export const getAutomatedAppsByOwnerSync = async (appOwner, status) => {
  const statusFilter = status ? `, status: "${status}"` : '';
  const qry = `query MyQuery {
    getAutomatedAppsByOwner(app_owner: "${appOwner}"${statusFilter})
  }`;
  return await executeQuerySync(qry);
};

export const updateAutomatedApp = (input, onSuccess, onFailure) => {
  const qry = `mutation MyMutation($input: AWSJSON!) {
    updateAutomatedApp(input: $input)
  }`;
  executeQuery(qry, onSuccess, onFailure, { input: JSON.stringify(input) });
};
